'use strict';

var React = require('react');

var SvgCalendarTickMajor = function SvgCalendarTickMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 2h2.5c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-15c0-.8.7-1.5 1.5-1.5h1.5v-1a1 1 0 0 1 2 0v1h7v-1a1 1 0 1 1 2 0v1zm2 16h-14v-10h14v10zm-4.707-7.707-3.293 3.293-1.293-1.293a1.001 1.001 0 0 0-1.707.707 1 1 0 0 0 .293.707l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414z"
  }));
};

exports.SvgCalendarTickMajor = SvgCalendarTickMajor;
